import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Btn, Empty, EstadoBadge, Field, Input, Spinner, TextArea } from "./ui";
import { UploadField } from "./UploadField";
import { errMsg, fmtDate } from "./api";

const Correccion = ({ client, envio, onDone }) => {
  const [desc, setDesc] = useState(envio.descripcion);
  const [titulo, setTitulo] = useState(envio.titulo);
  const [file, setFile] = useState(null);
  const [nota, setNota] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      await client.patch(`/mis-envios/${envio.id}`, { titulo, descripcion: desc, file_id: file?.file_id || null, nota });
      toast.success("Correcciones enviadas. Vuelve a revisión.");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-3 p-3 border border-blue-200 bg-blue-50 space-y-3" data-testid={`correccion-${envio.id}`}>
      <Field label="Título"><Input value={titulo} onChange={(e) => setTitulo(e.target.value)} data-testid="correccion-titulo" /></Field>
      <Field label="Descripción"><TextArea rows={3} value={desc} onChange={(e) => setDesc(e.target.value)} data-testid="correccion-descripcion" /></Field>
      <Field label="Reemplazar archivo (opcional)"><UploadField client={client} onUploaded={setFile} testid="correccion-archivo" /></Field>
      <Field label="Nota para moderación"><Input value={nota} onChange={(e) => setNota(e.target.value)} placeholder="¿Qué cambiaste?" data-testid="correccion-nota" /></Field>
      <Btn busy={busy} onClick={send} data-testid="correccion-enviar">Enviar correcciones</Btn>
    </div>
  );
};

export const MisEnvios = ({ client, refreshKey }) => {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(null);
  const load = useCallback(() => client.get("/mis-envios").then((r) => setItems(r.data)).catch(() => setItems([])), [client]);
  useEffect(() => { load(); }, [load, refreshKey]);

  if (items === null) return <Spinner />;
  if (items.length === 0) return <Empty>Todavía no enviaste material. ¡Subí tu primer video!</Empty>;
  return (
    <div className="bg-white border border-gray-200 divide-y" data-testid="mis-envios">
      {items.map((e) => (
        <div key={e.id} className="p-4" data-testid={`mi-envio-${e.id}`}>
          <button className="w-full flex items-center gap-3 text-left" onClick={() => setOpen(open === e.id ? null : e.id)}>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-[#0A192F] truncate">{e.titulo}</div>
              <div className="text-xs text-gray-500">{e.categoria} · enviado {fmtDate(e.created_at)}</div>
            </div>
            <EstadoBadge estado={e.estado} testid={`mi-envio-estado-${e.id}`} />
            {open === e.id ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </button>
          {open === e.id && (
            <div className="mt-3 text-sm">
              <ol className="space-y-2">
                {e.historial.map((h, i) => (
                  <li key={i} className="border-l-2 border-gray-300 pl-3">
                    <EstadoBadge estado={h.estado} /> <span className="text-xs text-gray-500">{new Date(h.fecha).toLocaleString("es-AR")}</span>
                    {h.comentario && <p className="text-[#374151] mt-0.5">{h.comentario}</p>}
                  </li>
                ))}
              </ol>
              {e.estado === "correcciones" && <Correccion client={client} envio={e} onDone={() => { setOpen(null); load(); }} />}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MisEnvios;
